import { Component, OnInit } from '@angular/core';
import { CommonService } from 'app/_services/common.service';

import { OrganisationsService } from 'app/_services/organisations.service';
import { MatSnackBar } from "@angular/material";
@Component({
  selector: 'app-queue-template',
  templateUrl: './queue-template.component.html',
  styleUrls: ['./queue-template.component.scss']
})
export class QueueTemplateComponent implements OnInit {
  queueTemplatList: any;
  totalRecords:any = 0;
  page = 0;
  organizationType:any
  size = 10;
  productLoading:Boolean=false
  queueTemplateFilter: any = {
    searchQueueTemplate: "",
    searchQueueTemplateStatus: "Active",
    searchorgtype: ""
  };
  constructor(
    private commonService:CommonService,
    private orgservice: OrganisationsService,
    private snackBar :MatSnackBar
  ) { }

  ngOnInit() {
    this.getOrganizationType()
    this.getQueueTemplateList(1, this.queueTemplateFilter);
  }

  getQueueTemplateList(page: number, queueTemplateFilter:any) {

    this.productLoading=true
    this.commonService.listQueueTemplates(page - 1, this.size, queueTemplateFilter).subscribe((response) => {
      if(response.status_code == 200){

        this.productLoading=false
        console.log("response.Data",response.Data)
        this.queueTemplatList = response.Data;
        this.totalRecords = response.total_count;
        this.page = page;
      }else{
        this.productLoading=false
        this.queueTemplatList = [];
        this.totalRecords = 0 ;
      
        this.snackBar.open(response.Metadata.Message, '', {
          duration: 2000,
          verticalPosition:"top",
          extraClasses: ['bg-red']
        });
      
      }
    },
      (err: any) => console.log("error", err),
      () =>
        console.log("getCustomersPage() retrieved customers for page:", +page)
    );
  }

  onSubmit() {

    console.log("onSubmit",this.queueTemplateFilter)

    this.getQueueTemplateList(1, this.queueTemplateFilter);
  }

  clearfilter() {
    this.queueTemplateFilter.searchQueueTemplate = "";
    this.queueTemplateFilter.searchQueueTemplateStatus = "";
    this.queueTemplateFilter.searchorgtype=""
    this.getQueueTemplateList(1, this.queueTemplateFilter);
  }

  pageChanged(event) {
    this.getQueueTemplateList(event, this.queueTemplateFilter);
  }

  getOrganizationType(){

this.productLoading=true

    this.orgservice.getOrganizationType().subscribe((response)=>{
  
      this.productLoading=false
  console.log("response.Data",response.Data)
  
        this.organizationType = response.Data
    })
  }

}



// WEBPACK FOOTER //
// ./src/app/component/queue-template/queue-template.component.ts